import React from "react"
import { Redirect } from "react-router"
import styled from "styled-components"
import { useUser, userIsAdmin } from "../../helpers/user"
import AddUserForm from "./adduserform"

const Styles = styled.div`
    max-width: 480px;
    margin: 24px auto;
    padding: 28px 32px;
    background: #FFFFFFEE;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);

    h2 {
        margin-bottom: 24px;
        font-size: 1.4em;
    }

    @media (max-width: 480px) {
        margin: 0;
        border-radius: 0;
        box-shadow: none;
        padding: 20px 16px;
        width: 100%;
        min-height: 100vh;
    }
`

export default function AddUserPage() {
    const { user, userLoading } = useUser()
    if (userLoading) return null
    if (!user || !userIsAdmin(user)) return <Redirect to='/'/>

    return <Styles>
        <h2>Add User</h2>
        <AddUserForm/>
    </Styles>
}
